import { EOrderStatus } from '@type/order';
import { Tag } from 'antd';

interface OrderStatusTagProps {
  status: EOrderStatus;
}

export function OrderStatusTag({ status }: OrderStatusTagProps) {
  const getStatusConfig = (status: EOrderStatus) => {
    switch (status) {
      case EOrderStatus.PENDING:
        return { label: 'Chờ xử lý', color: 'orange' };
      case EOrderStatus.SHIPPING:
        return { label: 'Đang giao', color: 'blue' };
      case EOrderStatus.COMPLETED:
        return { label: 'Hoàn thành', color: 'green' };
      case EOrderStatus.CANCELED:
        return { label: 'Đã hủy', color: 'red' };
      default:
        return { label: 'Không xác định', color: 'default' };
    }
  };

  const config = getStatusConfig(status);

  return <Tag color={config.color}>{config.label}</Tag>;
}
